// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/range-endurance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/range-endurance/endurance-technique.js';
import g1 from '../lessons/aeronautics/range-endurance/range-endurance.js';

mount([g0, g1]);
